// This file contains the utility functions for data in Model transform
import { Cartesian3, Ray } from "cesium";
export var PositionReference;
(function (PositionReference) {
    PositionReference[PositionReference["ABOVE"] = 0] = "ABOVE";
    PositionReference[PositionReference["BELOW"] = 1] = "BELOW";
    PositionReference[PositionReference["OUTSIDE"] = 2] = "OUTSIDE";
})(PositionReference || (PositionReference = {}));
export function checkPositionWrtToTileset(point, tileset) {
    const rayOrigin = new Cartesian3(point.x, point.y, point.z + 1000);
    const pointOnTileset = tileset.rayCast(new Ray(rayOrigin, new Cartesian3(0, 0, -1)));
    if (pointOnTileset)
        return pointOnTileset.z <= point.z
            ? PositionReference.ABOVE
            : PositionReference.BELOW;
    return PositionReference.OUTSIDE;
}
//# sourceMappingURL=local-utilities.js.map